export async function getFormUrl(formName: string): Promise<string> {
  if (formName.includes('邮件订阅') || formName.includes('订阅')) {
    return 'https://readdy.ai/api/form/d9peeqdi2vhsdh2d32jg';
  }
  if (formName.includes('联系我们') || formName.includes('联系')) {
    return 'https://readdy.ai/api/form/d9peeqdi2vhsdh2d32jg';
  }
  return 'https://readdy.ai/api/form/d9peeqdi2vhsdh2d32jg';
}